var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_51",
    "data-name": "Layer 51",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #c2c7cc;\n        opacity: .25;\n      }\n\n      .cls-3 {\n        fill: #4f7fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 250,
    cy: 250,
    r: 162.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 250,
    cy: 250,
    r: 125
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.78,307.87c-4.44,0-8.9-1.54-12.5-4.67l-43.8-37.93c-7.98-6.9-8.85-18.97-1.93-26.96,6.91-7.96,18.98-8.85,26.95-1.93l30.06,26.03,61.66-64.38c7.31-7.64,19.39-7.89,27.02-.58,7.62,7.29,7.88,19.4.58,27.01l-74.23,77.52c-3.74,3.92-8.76,5.9-13.81,5.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.dd208a37e23aa30398cd523fa9d9d4bb.svg";
export { ForwardRef as ReactComponent };